(function($){
    "use strict"; // Start of use strict
    var stickyHeaderTop =0, winW, winH, winScr;
    if( $('#header .main-menu').length > 0){
      stickyHeaderTop = $('#header .main-menu').offset().top;
    }
    
     /* ---------------------------------------------
     Stick menu
     --------------------------------------------- */
     function kutetheme_ovic_stick_menu(){

      /*if($('#header .main-menu').length >0){
          var h = $(window).scrollTop();
          var width = $(window).width();
          if(width > 991){

              if((h > stickyHeaderTop) ){
                  kutetheme_ovic_clone_header_ontop();
                  $('#header-ontop').addClass('on-sticky');
                  $('#header-ontop').find('.header').addClass('ontop');
              }else{
                  $('#header-ontop').removeClass('on-sticky');
                  $('#header-ontop').find('.header').removeClass('ontop');
              }
          }else{
              $('#header-ontop').find('.header').removeClass('ontop');
              $('#header-ontop').removeClass('on-sticky');
          }
      }*/
     }
     
    /* ---------------------------------------------
     Owl carousel
     --------------------------------------------- */
    function kutetheme_ovic_carousel(){
        $('.owl-carousel, .enable-carousel').each(function(){
            var owl = $(this);
            var config = owl.data();
            var animateOut = owl.data('animateout');
            var animateIn = owl.data('animatein');
            var slidespeed = owl.data('slidespeed');
            var navigation_next_text = owl.data('navigation_next_text');
            var navigation_prev_text = owl.data('navigation_prev_text');
            var navigation_type = owl.data('navigation_style');
            var navcontainer = owl.data('navcontainer');
            if( (typeof(navcontainer) != 'undefined')){
              config.navContainer = navcontainer;
            }
            if( (typeof(navigation_type) != 'undefined')){
                if(navigation_type == 'custom'){
                    config.navText = ['<i class="custom-left"></i>','<i class="custom-right"></i>'];
                }else{
                    if( (typeof(navigation_next_text) != 'undefined') && (typeof(navigation_prev_text) != 'undefined')){
                        navigation_prev_text = '<span class="text">'+owl.data('navigation_next_text')+'</span>';
                        navigation_next_text = '<span class="text">'+owl.data('navigation_prev_text')+'</span>';
                        config.navText = [navigation_prev_text,navigation_next_text];
                    }else{
                        config.navText = ['<span class="text"><i class="flaticon-left-arrow"></i></span>','<span class="text"><i class="flaticon-right-arrow"></i></span>'];
                    }
                }
            }else{
                if( (typeof(navigation_next_text) != 'undefined') && (typeof(navigation_prev_text) != 'undefined')){
                    navigation_prev_text = '<span class="text">'+owl.data('navigation_next_text')+'</span>';
                    navigation_next_text = '<span class="text">'+owl.data('navigation_prev_text')+'</span>';
                    config.navText = [navigation_prev_text,navigation_next_text];
                }else{
                    config.navText = ['<span class="text"><i class="flaticon-left-arrow"></i></span>','<span class="text"><i class="flaticon-right-arrow"></i></span>'];
                }
            }
            if(typeof(animateOut)  != 'undefined' ){
                config.animateOut = animateOut;
            }
            if(typeof(animateIn) != 'undefined' ){
                config.animateIn = animateIn;
            }

            if( typeof(slidespeed) != 'undefined' ){
                config.smartSpeed = slidespeed;
            }else{
              config.smartSpeed = 1000;
            }
            
            if( owl.hasClass('enable-carousel') ){
                owl.find('.on-carousel').owlCarousel(config);
            }else{
                owl.owlCarousel(config);
            }
        });
    }
    /* ---------------------------------------------
     Owl carousel mobile
     --------------------------------------------- */
    function kutetheme_ovic_init_carousel_mobile(){
        var window_size = jQuery('body').innerWidth();
        window_size += kutetheme_ovic_get_scrollbar_width();
        if( window_size < 768 ){
          $('.owl-carousel-mobile').each(function(){
            var config = $(this).data();
            var animateOut = $(this).data('animateout');
            var animateIn = $(this).data('animatein');
            config.navText = ['<span class="text"><i class="flaticon-left-arrow"></i></span>','<span class="text"><i class="flaticon-right-arrow"></i></span>'];
            if(typeof animateOut != 'undefined' ){
              config.animateOut = animateOut;
            }
            if(typeof animateIn != 'undefined' ){
              config.animateIn = animateIn;
            }
            var owl = $(this);
            owl.owlCarousel(config);
          });
        }else{
            $('.owl-carousel-mobile').each(function(){
                var owl = $(this);
                owl.trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded');
                owl.find('.owl-stage-outer').children().unwrap();
            })
        }
        
    }
    /* ---------------------------------------------
     MENU REPONSIIVE
     --------------------------------------------- */
     function kutetheme_ovic_init_menu_reposive(){
          var kt_is_mobile = (Modernizr.touch) ? true : false;
          if(kt_is_mobile === true){
            $(document).on('click', '.kt-nav .menu-item-has-children > a', function(e){
              var licurrent = $(this).closest('li');
              var liItem = $('.kt-nav .menu-item-has-children');
              if ( !licurrent.hasClass('show-submenu') ) {
                liItem.removeClass('show-submenu');
                licurrent.parents().each(function (){
                    if($(this).hasClass('menu-item-has-children')){
                     $(this).addClass('show-submenu');   
                    }
                      if($(this).hasClass('main-menu')){
                          return false;
                      }
                })
                licurrent.addClass('show-submenu');
                // Close all child submenu if parent submenu is closed
                if ( !licurrent.hasClass('show-submenu') ) {
                  licurrent.find('li').removeClass('show-submenu');
                  }
                  return false;
                  e.preventDefault();
              }else{
                var href = $this.attr('href');
                  if ( $.trim( href ) == '' || $.trim( href ) == '#' ) {
                      licurrent.toggleClass('show-submenu');
                  }
                  else{
                      window.location = href;
                  } 
              }
              // Close all child submenu if parent submenu is closed
                  if ( !licurrent.hasClass('show-submenu') ) {
                      //licurrent.find('li').removeClass('show-submenu');
                  }
                  e.stopPropagation();
          });
         
          
        $(document).on('click', function(e){
              var target = $( e.target );
              if ( !target.closest('.show-submenu').length || !target.closest('.kt-nav').length ) {
                  $('.show-submenu').removeClass('show-submenu');
              }
          }); 
          // On Desktop
          }else{
            
              $(document).on('mousemove','.kt-nav .menu-item-has-children',function(){
                  $(this).addClass('show-submenu');  
                  var window_size = jQuery('body').innerWidth();
                  window_size += kutetheme_ovic_get_scrollbar_width();
                  if( window_size > 991 ){   
                    var enable_effect_menu = $("#enable_effect_menu").val(); 
                    var effect_menu = $("#effect_menu").val();                    
                    if(enable_effect_menu == 'true'){
                      	$("#header").find(this).find('.sub-menu ').animateCss(effect_menu);
                    }
                    
                  }

              })

              $(document).on('mouseout','.kt-nav .menu-item-has-children',function(){
                  $(this).removeClass('show-submenu');
              })
          }
       
     }
    /* ---------------------------------------------
     Resize mega menu
     --------------------------------------------- */
     function kutetheme_ovic_resizeMegamenu(){
        var window_size = jQuery('body').innerWidth();
        window_size += kutetheme_ovic_get_scrollbar_width();
        if( window_size > 767 ){
          if( $('#header .main-menu-wapper').length >0){
            var container = $('#header .main-menu-wapper');
            if( container!= 'undefined'){
              var container_width = 0;
              container_width = container.innerWidth();
              var container_offset = container.offset();
              setTimeout(function(){
                  $('.main-menu .item-megamenu').each(function(index,element){
                      $(element).children('.megamenu').css({'max-width':container_width+'px'});
                      var sub_menu_width = $(element).children('.megamenu').outerWidth();
                      var item_width = $(element).outerWidth();
                      $(element).children('.megamenu').css({'left':'-'+(sub_menu_width/2 - item_width/2)+'px'});
                      var container_left = container_offset.left;
                      var container_right = (container_left + container_width);
                      var item_left = $(element).offset().left;
                      var overflow_left = (sub_menu_width/2 > (item_left - container_left));
                      var overflow_right = ((sub_menu_width/2 + item_left) > container_right);
                      if( overflow_left ){
                        var left = (item_left - container_left);
                        $(element).children('.megamenu').css({'left':-left+'px'});
                      }
                      if( overflow_right && !overflow_left ){
                        var left = (item_left - container_left);
                        left = left - ( container_width - sub_menu_width );
                        $(element).children('.megamenu').css({'left':-left+'px'});
                      }
                  })
              },100);
            }
          }
        }
     }
     function kutetheme_ovic_get_scrollbar_width() {
        var $inner = jQuery('<div style="width: 100%; height:200px;">test</div>'),
            $outer = jQuery('<div style="width:200px;height:150px; position: absolute; top: 0; left: 0; visibility: hidden; overflow:hidden;"></div>').append($inner),
            inner = $inner[0],
            outer = $outer[0];
        jQuery('body').append(outer);
        var width1 = inner.offsetWidth;
        $outer.css('overflow', 'scroll');
        var width2 = outer.clientWidth;
        $outer.remove();
        return (width1 - width2);
    }
    /* ---------------------------------------------
     Height Full
     --------------------------------------------- */
    function kutetheme_ovic_js_height_full(){
        (function($){
            var height = $(window).outerHeight();
            $(".full-height").css("height",height);
        })(jQuery);
    }
    function kutetheme_ovic_js_width_full(){
        (function($){
            var width = $(window).outerWidth();
            $(".full-width").css("width",width);
        })(jQuery);
    }
    /* ---------------------------------------------
     Woocommerce Quantily
     --------------------------------------------- */
     function kutetheme_ovic_woo_quantily(){
        $('body').on('click','.quantity .quantity-plus',function(){
            var obj_qty  = $(this).closest('.quantity').find('input.qty'),
                val_qty  = parseInt(obj_qty.val()),
                min_qty  = parseInt(obj_qty.data('min')),
                max_qty  = parseInt(obj_qty.data('max')),
                step_qty = parseInt(obj_qty.data('step'));
            val_qty = val_qty + step_qty;
            if(max_qty && val_qty > max_qty){ val_qty = max_qty; }
            obj_qty.val(val_qty);
            obj_qty.trigger("change");
            return false;
        });

        $('body').on('click','.quantity .quantity-minus',function(){
            var obj_qty  = $(this).closest('.quantity').find('input.qty'), 
                val_qty  = parseInt(obj_qty.val()),
                min_qty  = parseInt(obj_qty.data('min')),
                max_qty  = parseInt(obj_qty.data('max')),
                step_qty = parseInt(obj_qty.data('step'));
            val_qty = val_qty - step_qty;
            if(min_qty && val_qty < min_qty){ val_qty = min_qty; }
            if(!min_qty && val_qty < 0){ val_qty = 0; }
            obj_qty.val(val_qty);
            obj_qty.trigger("change");
            return false;
        });
    }

    /* ---------------------------------------------
     TAB EFFECT
    --------------------------------------------- */
    function kutetheme_ovic_tab_fade_effect(){
      // effect click
      $(document).on('click','.kt-tabs-animate .kt-tab a',function(){
        var tab_id = $(this).attr('href');
        var tab_animated = $(this).data('animate');
        
        tab_animated = ( tab_animated == undefined || tab_animated =="" ) ? '' : tab_animated;
        if( tab_animated ==""){
          return  false;
        }

        $(tab_id).find('.product-list-grid > .product-item, .owl-item.active ').each(function(i){

            var t = $(this);
            var style = $(this).attr("style");
            style     = ( style == undefined ) ? '' : style;
            var delay  = i * 400;
            t.attr("style", style +
                      ";-webkit-animation-delay:" + delay + "ms;"
                    + "-moz-animation-delay:" + delay + "ms;"
                    + "-o-animation-delay:" + delay + "ms;"
                    + "animation-delay:" + delay + "ms;"
            ).addClass(tab_animated+' animated').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                t.removeClass(tab_animated+' animated');
                t.attr("style", style);
            });
        })
      })
    }
    
    function kutetheme_ovic_clone_main_menu(){
        if( $('#header .clone-main-menu').length > 0 && $('#box-mobile-menu').length >0){
          $( "#header .clone-main-menu" ).clone().appendTo( "#box-mobile-menu .box-inner" );
          $('#box-mobile-menu').find('.clone-main-menu').removeAttr('id');
        }
    }

    function kutetheme_ovic_clone_header_ontop(){
        if( $('#header').length > 0 && $('#header-ontop').length >0 ){
          if( $('#header-ontop').find('.header').length <= 0 ){
            var content = $( "#header" ).clone();
            content.removeAttr('id');
            content.appendTo( "#header-ontop" );
          }
        }
    }
    /* ---------------------------------------------
     Height Full
     --------------------------------------------- */
    function js_height_full(){
        (function($){
            var height = $(window).outerHeight();
            var bar_height = $('#wpadminbar').outerHeight();
            height = height - bar_height;
            $(".full-height").css("height",height);
        })(jQuery);
    }
    function js_width_full(){
        (function($){
            var width = $(window).outerWidth();
            $(".full-width").css("width",width);
        })(jQuery);
    }
    /**==============================
    Auto width Vertical menu
    ===============================**/
    function kt_auto_width_vertical_menu(){
        var full_width = parseInt($('body').innerWidth());
        var menu_width = parseInt($('.verticalmenu-content').actual('width'));
        var w = (full_width - menu_width);
        $('.verticalmenu-content').find('.megamenu').each(function(){
            $(this).css('max-width',w+'px');
        });
    }

    function kt_home_slide(){
        var window_size = jQuery('body').innerWidth();
        window_size += kutetheme_ovic_get_scrollbar_width();

        $('.kt_home_slide').each(function(){
          // Seting
          $(this).find('.item-slide').each(function(){
            var background = $(this).data('background');
            var height = $(this).data('height');
            var reponsive = $(this).data('reponsive');
            if( typeof(background) != 'undefined'){
              $(this).css({
               'background-image':'url('+background+')'
              });
            }
            if( typeof(height) != 'undefined'){
              if( height == "full"){
                height = '100vh';
              }else{
                 height = height+'px';
              }
             
              $(this).css({
               'height':height
              });
            }
            if (typeof(reponsive) != 'undefined'){
              //console.log(window_size);
               for (var k in reponsive){
                    if (typeof reponsive[k] !== 'function') {
                        if( window_size <= k ){
                          if( reponsive[k] > 0 ){
                            $(this).css({
                              'min-height':reponsive[k]+'px',
                              'height':reponsive[k]+'px'
                            });
                            break;
                          }
                        }
                    }
                }
             }
          })

          /* OWL */
          var owl = $(this);
          var config = $(this).data();
          config.navText = ['<i class="flaticon-left-arrow"></i>','<i class="flaticon-right-arrow"></i>'];
          var animateOut = $(this).data('animateout');
          var animateIn = $(this).data('animatein');
          var smartSpeed = $(this).data('smartspeed');
          
          
          if(typeof (animateOut) != 'undefined' ){
            config.animateOut = animateOut;
          }
          if(typeof (animateIn) != 'undefined' ){
            config.animateIn = animateIn;
          }

          if( typeof smartSpeed != 'undefined'){
              config.smartSpeed = smartSpeed;
          }else{
            config.smartSpeed = 1000;
          }
          owl.owlCarousel(config);
          owl.trigger('next.owl.carousel');
          owl.on('changed.owl.carousel', function(property) {
            var current = property.item.index;
            $(property.target).find(".owl-item").eq(current).find(".caption").each(function(i){
                var t = $(this);
                var style = $(this).attr("style");
                style     = ( style == undefined ) ? '' : style;
                var delay  = i+1 * 1000;
                var animate = t.data('animate');
                t.attr("style", style +
                          ";-webkit-animation-delay:" + delay + "ms;"
                        + "-moz-animation-delay:" + delay + "ms;"
                        + "-o-animation-delay:" + delay + "ms;"
                        + "animation-delay:" + delay + "ms;"
                ).addClass('animated '+ animate).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                    $(this).removeClass('animated '+animate);
                });
                
            })
          })
        });
    }
    function kt_banner(){
      //Shortcode Banner
      $('.kt-banner').each(function(){
        var window_size = jQuery('body').innerWidth();
        window_size += kutetheme_ovic_get_scrollbar_width();
         var minHeight = $(this).data('height'),
         bgimg = $(this).data('background'),
         bgcolor = $(this).data('bgcolor');
         var bgcontainer =  $(this).find('.bg-image');
         var content = $(this).find('.content');
         var reponsive = $(this).data('reponsive');
         bgcontainer.css({
            'min-height':minHeight+'px',
            'height':minHeight+'px'
         });

       if( typeof (bgimg)!= 'undefined' && bgimg !=""){
            bgcontainer.css({
             'background-image':'url('+bgimg+')'
            });
         }

         if( typeof (bgcolor) != 'undefined' && bgcolor !=""){
            bgcontainer.css({
             'background-color':bgcolor
            });
         }

         if (typeof(reponsive) != 'undefined'){
          //console.log(window_size);
           for (var k in reponsive){
                if (typeof reponsive[k] !== 'function') {
                    if( window_size <= k ){
                      if( reponsive[k] > 0 ){
                        bgcontainer.css({
                          'min-height':reponsive[k]+'px',
                          'height':reponsive[k]+'px'
                        });
                        break;
                      }
                    }
                }
            }
         }
      });
     }
      /* ---------------------------------------------
     Parallax
     --------------------------------------------- */
     function kt_parallax(){
        var window_size = jQuery('body').innerWidth();
        window_size += kutetheme_ovic_get_scrollbar_width();
        if( window_size > 767){
            $('.bg-parallax').parallax('50%', 0.3);
        }
     }
     /* ---------------------------------------------
     COUNTDOWN
     --------------------------------------------- */
     function kt_countdown(){
        if($('.kt-countdown').length >0){
          var labels = ['Years', 'Months', 'Weeks', 'Days', 'Hrs', 'Mins', 'Secs'];
          var layout = '<span class="box-count day"><span class="number">{dnn}</span> <span class="text">Days</span></span><span class="dot">:</span><span class="box-count hrs"><span class="number">{hnn}</span> <span class="text">Hrs</span></span><span class="dot">:</span><span class="box-count min"><span class="number">{mnn}</span> <span class="text">Mins</span></span><span class="dot">:</span><span class="box-count secs"><span class="number">{snn}</span> <span class="text">Secs</span></span>';
          $('.kt-countdown').each(function() {
              var austDay = new Date($(this).data('y'),$(this).data('m') - 1,$(this).data('d'),$(this).data('h'),$(this).data('i'),$(this).data('s'));
              $(this).countdown({
                  until: austDay,
                  labels: labels, 
                  layout: layout
              });
          });
        }
     }

      /* ---------------------------------------------
     Init popup
     --------------------------------------------- */
    function init_popup(){
        if($(window).width() + kutetheme_ovic_get_scrollbar_width() >= 768){
            if($('body').hasClass('home')){
                //Open directly via API
                $.magnificPopup.open({
                  items: {
                    src:'.white-popup',
                    //src: '<div class="white-popup"><div class="kt-popup-newsletter"></div></div>',  //can be a HTML string, jQuery object, or CSS selector
                    type: 'inline'
                  }
                });
            }
        }
    }
    /* ---------------------------------------------
     Scripts initialization
     --------------------------------------------- */
    $(window).load(function() {
        winW = $(window).width();
        winH = $(window).height();
      // Resize Megamenu
        kutetheme_ovic_resizeMegamenu();
        kutetheme_ovic_init_carousel_mobile();
        kutetheme_ovic_stick_menu();
        kutetheme_ovic_clone_main_menu();
        kt_auto_width_vertical_menu();
      
      	/* ---------------------------------------------
     Remmember Newsletter
 --------------------------------------------- */      
      if($.cookie("remmember_newsletter"))
        var index = $.cookie("remmember_newsletter");
      else
        var index = 0;
      
      $(document).on("click","#chks_newsletter", function(event) {      
        index++;
        if(index>1) index=0;
        $.cookie("remmember_newsletter", index, { expires: 3 });
      });

      if($.cookie("remmember_newsletter")==1){      
        index = 1;
      }
      
      if(index == 0){
        init_popup();
      }
        

        
        $('.owl-custom-nav-postion').each(function(){
              var margin = $(this).data('navigation_margin');
              if( typeof (margin) != 'undefined' ){
                  if( $(this).hasClass('nav-center-outside') || $(this).hasClass('nav-center-outside')){
                     $(this).find('.owl-nav .owl-prev, .owl-nav .owl-next').css({'top':margin});
                  }else{
                    $(this).find('.owl-nav').css({'top':margin});
                  }
                  
              }
          })
        });
    /* ---------------------------------------------
     Scripts resize
     --------------------------------------------- */
    $(window).on("resize", function() {
        winW = $(window).width();
        winH = $(window).height();
      // Resize Megamenu
        kutetheme_ovic_resizeMegamenu();
        kutetheme_ovic_init_carousel_mobile();
        js_height_full();
        js_width_full();
        kt_auto_width_vertical_menu();
        kt_banner();
        kt_home_slide();
        
        
    });
    /* ---------------------------------------------
     Scripts scroll
     --------------------------------------------- */
    $(window).scroll(function(){
      // Resize Megamenu
      kutetheme_ovic_resizeMegamenu();
      kutetheme_ovic_stick_menu();
      // Show hide scrolltop button
        if( $(window).scrollTop() == 0 ) {
            $('.scroll_top').stop(false,true).fadeOut(600);
        }else{
            $('.scroll_top').stop(false,true).fadeIn(600);
        }
    });
    /* ---------------------------------------------
     Scripts ready
     --------------------------------------------- */
    $(document).ready(function() {

        // OWL CAROUSEL
        kutetheme_ovic_carousel();
        //MENU REPONSIIVE
        kutetheme_ovic_init_menu_reposive();
        // Resize Megamenu
        kutetheme_ovic_resizeMegamenu();
        kutetheme_ovic_init_carousel_mobile();
        kutetheme_ovic_stick_menu();
        kutetheme_ovic_woo_quantily();
        kutetheme_ovic_tab_fade_effect();
        js_height_full();
        js_width_full();
        kt_home_slide();
        kt_banner();
        kt_countdown();
        kt_parallax();
        // CATEGORY FILTER 
        /*$('.slider-range-price').each(function(){
            var min             = $(this).data('min');
            var max             = $(this).data('max');
            var unit            = $(this).data('unit');
            var value_min       = $(this).data('value-min');
            var value_max       = $(this).data('value-max');
            var label_reasult   = $(this).data('label-reasult');
            var t               = $(this);
            $( this ).slider({
              range: true,
              min: min,
              max: max,
              values: [ value_min, value_max ],
              slide: function( event, ui ) {
                var result_min = ' <span>'+ unit + ui.values[ 0 ] +' </span>';
                var result_max = ' <span>'+ unit + ui.values[ 1 ] +' </span>';
                t.find('.ui-slider-handle:first').html(result_min);
                t.find('.ui-slider-handle:last').html(result_max);
                // var result = label_reasult +" <span>"+ unit + ui.values[ 0 ] +' </span> - <span> '+ unit +ui.values[ 1 ]+'</span>';
                // t.closest('.price_slider_wrapper').find('.amount-range-price').html(result);
              },
              create: function( event, ui ) {
                var result_min = ' <span>'+ unit + value_min +' </span>';
                var result_max = ' <span>'+ unit + value_max +' </span>';
                t.find('.ui-slider-handle:first').html(result_min);
                t.find('.ui-slider-handle:last').html(result_max);
              }
            });
        });*/


        // OPEN SEARCH
        $(document).on('click','.box-search-icon .icon',function(){
            $(this).closest('.box-search-icon').toggleClass('open');
        })
        
        // CLOSE SEARCH
        $(document).on('click','.box-search-icon .close-boxsearch',function(){
            $(this).closest('.box-search-icon').toggleClass('open');
        })

        /*if( $('.woocommerce-ordering .orderby').length > 0 ){
            $('.woocommerce-ordering .orderby').chosen();
        }*/
        $('.single-product-page .entry-summary select').chosen();
        $('table.cart select').chosen();

        // View grid list product
        /*$(document).on('click','.show-grid-list .display-mode',function(){
            var mode = $(this).data('mode');
            var current_url  = window.location.href;
            current_url = current_url.replace("#", "");
            var data = {
                action: 'fronted_set_products_view_style',
                //security : kt_ajax_fontend.security,
                mode: mode
            };
           // $.post(kt_ajax_fontend.ajaxurl, data, function(response){
                //window.location.replace(current_url);
            //})
            
          
            $.post(data, function(response){
                window.location.replace(current_url);
            })
            return false;
        });*/

        // BOX MOBILE MENU
        $(document).on('click','.mobile-navigation',function(){
            $('#box-mobile-menu').addClass('open');
            return false;
        });
        // Close box menu
        $(document).on('click','#box-mobile-menu .close-menu',function(){
            $('#box-mobile-menu').removeClass('open');
            return false;
        });
        //  Box mobile menu
        // if($('#box-mobile-menu').length >0 ){
        //     $("#box-mobile-menu").mCustomScrollbar();
        // }

        // Scroll top
        $(document).on('click','.scroll_top',function(){
            $('body,html').animate({scrollTop:0},400);
            return false;
        });
        
        //mini cart
        $(document).on('click','.mini-cart .cart-link',function(){
            var content = $(this).closest('body').find('.minicart-content');
            if( content.length > 0 ){
                content.addClass('open');
                return false;
            }
        })
        
        $(document).on('click','.close-minicart',function(){
            $(this).closest('body').find('.minicart-content').removeClass('open');
        })
        
        // Box search
        $(document).on('click','.icon-search',function(){
            var content = $(this).closest('body').find('.search-control');
            if( content.length > 0 ){
                content.addClass('open');
                return false;
            }
        })
        
        $(document).on('click','.close-search-control',function(){
            $(this).closest('body').find('.search-control').removeClass('open');
        })
        // Box account
        $(document).on('click','.icon-account',function(){
            var content = $(this).closest('body').find('.account-control');
            if( content.length > 0 ){
                content.addClass('open');
                return false;
            }
        })
        
        $(document).on('click','.close-account-control',function(){
            $(this).closest('body').find('.account-control').removeClass('open');
        })
        
        //$(".account-control,.search-control,.minicart-content").mCustomScrollbar();


        $(document).on('click','.toggle-menu-bar',function(){
          $(this).toggleClass('selected');
          $(this).closest('.header').find('.main-menu').toggleClass('open');
          setTimeout(function(){
              $(window).resize();
          },100);
          return false;
        })

        $(document).on('click','.bar-header',function(){
            $('#header.header-vetical').toggleClass('open');
        })

        if($('#header.header-vetical .header-inner').length >0 ){
            //$("#header.header-vetical .header-inner").mCustomScrollbar();
        }


        //VIDEO LIGHTBOX
        if ( $('.video-lightbox .link-lightbox').length ){
          $('.video-lightbox .link-lightbox').simpleLightboxVideo();
        }

        $('.product-images').bxSlider({
          pagerCustom: '#product-thumbs',
          nextText:'<span class="flaticon-right-arrow"></span>',
          prevText:'<span class="flaticon-left-arrow"></span>'
        });

        $(document).on('click','.header-bar-link',function(){
          $(this).closest('.header').toggleClass('open');
          return false;
        })

        $(document).on('click','.tongle-bar',function(){
          $(this).closest('.header').find('.header-main').toggleClass('open');
          return false;
        })

        $(document).on('click','.button-open-filter',function(){
            $(this).toggleClass('open');
            $(this).closest('.kt_megacategories').find('.group-filter').slideToggle();
            return false;
        })

        /* Send conttact*/
        $(document).on('click','#btn-send-contact',function(){
                var email   = $('#email').val(),
                name = $('#name').val(),
                content = $('#content').val(),
                subject = $('#subject').val();
            var data = {
                email:email,
                content:content,
                name:name,
                subject:subject
            }

            $(this).html('Loading...');
            var t = $(this);
            $.post('ajax_contact.php',data,function(result){
                if(result.trim()=="done"){
                    $('#email').val('');
                    $('#content').val('');
                    $('#name').val('');
                    $('#subject').val('');
                    $('#message-box-conact').html('<div class="alert alert-info">Your message was sent successfully. Thanks</div>');
                }else{
                    $('#message-box-conact').html(result);
                }
                t.html('SEND MESSAGE');
            })
        })
        
    });


})(jQuery); // End of use strict
